export const ColorModeEnum = {
    Dark: 1,
    Light: 2
}
export const ColorModeNameEnum = {
    1: 'dark',
    2: 'light'
}
export const ColorModeSportNameEnum = {
    'dark': 'default',
    'light':'alternative'
}
export const COLOR_MODE_KEY = 'colorMode'

